import { Component } from '@angular/core';
import { ToolboxModule } from 'src/app/shared/toolbox/toolbox.module';


@Component({
  selector: 'app-error-screen',
  templateUrl: './error-screen.component.html',
  styleUrls: ['./error-screen.component.scss'],
})
export class ErrorScreenComponent {
  reportError(): void {
    // Implement the logic for reporting errors
    console.log('Error reported!'); // Placeholder for actual reporting logic

    // You can show a modal, redirect to a feedback form, or send an API request here
    // For example:
    // this.http.post('api/report-error', { errorDetails: 'Details about the error...' })
    //   .subscribe(response => {
    //     console.log('Error reported successfully', response);
    //   });
  }
}
